import { DeserializeFilters } from '../../../hooks/table-pages/use-endpoint-query-parameters'
import qs from 'qs'

interface FilterFormValues {
    orderStatus?: string
    client?: string
}

export const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FilterFormValues>
    const { orderStatus, client } = formValues

    const filters: Record<string, unknown> = {}

    if (orderStatus) {
        filters.orderStatus = { $eq: orderStatus }
    }

    if (client) {
        filters.client = {
            documentId: { $eq: client },
        }
    }

    return filters
}
